import {
  Component,
  EventEmitter,
  Input,
  OnDestroy,
  OnInit,
  Output
} from '@angular/core';
import {roles, rolesLabelMap} from "../../../../../constants/common.constants";
import {
  UpdatePasswordFormComponent
} from "../../../../update-password-form/update-password-form.component";
import {CommonService} from "../../../../../services/common.service";
import {Store} from '@ngrx/store';
import {TriggerNotificationRequest} from "../../../../../core/shared.actions";
import {
  NotificationTypeKeyMap
} from "../../../../../constants/notification.config";
import {
  usersList
} from "../../../../../../page-modules/manage-users/core/manage-users.selectors";
import {
  ForgotPasswordRequest
} from "../../../../../../authentication/core/authentication.actions";
import {Subject, takeUntil} from "rxjs";
import {
  forgotPasswordInfo
} from "../../../../../../authentication/core/authentication.selectors";
import {environment} from '../../../../../../../../environments/environment';

@Component({
  selector: 'app-non-editable-user-details',
  templateUrl: './non-editable-user-details.component.html',
  styleUrls: ['./non-editable-user-details.component.css']
})
export class NonEditableUserDetailsComponent implements OnInit, OnDestroy {
  @Input() userDetails;
  @Output() handleClick = new EventEmitter();
  @Input() hasUserId: boolean;
  @Input() loggedInUserRole: number;
  resetPasswordLoading: boolean = true;
  protected readonly rolesLabelMap = rolesLabelMap;
  protected readonly roles = roles;
  protected readonly usersList = usersList;
  private readonly onDestroy: Subject<any> = new Subject<any>();

  constructor(
    private commonService: CommonService,
    private store: Store
  ) {

  }

  ngOnInit() {
    this.store.select(forgotPasswordInfo)
      .pipe(takeUntil(this.onDestroy))
      .subscribe(data => {
        this.resetPasswordLoading = data.loading;
      })

  }

  editUserDetails() {
    this.handleClick.emit(event)
  }

  hippaConsentClicked() {
    const url = `${environment.cdnBaseUrl}${this.userDetails.consentLink}`;
    window.open(url);
  }

  hippaAssentClicked() {
    const url = `${environment.cdnBaseUrl}${this.userDetails.assentLink}`;
    window.open(url);
  }

  openUpdatePasswordModalWindow() {
    this.commonService.openDialog({
      data: {
        component: UpdatePasswordFormComponent,
      },
      panelWidth: 40
    });
  }

  resetPassword() {
    const payload = {
      username: this.userDetails.username
    };
    this.store.dispatch(ForgotPasswordRequest({payload}));
  }

  triggerNotification(type: string) {
    this.store.dispatch(TriggerNotificationRequest({
      payload: {
        userId: this.userDetails.id,
        type: NotificationTypeKeyMap[type]
      }
    }))
  }

  ngOnDestroy() {
    this.onDestroy.next(null);
    this.onDestroy.complete();
  }
}
